import mixpanel from 'mixpanel-browser';
import { env } from '@/@configs/env';

const token: string | undefined = env.get('VITE_MIXPANEL_TOKEN');
const mode: string = env.get('MODE');
const isDevelopment = mode === 'development';
const isEnabledEnvironment =
  mode === 'production' ||
  (isDevelopment && env.get('VITE_MIXPANEL_DEV_ENABLED') === 'true');

export const isMixpanelEnabled = () => isEnabledEnvironment && Boolean(token);

export const registerEnvironment = () =>
  mixpanel.register({ environment: mode });

export const initializeMixpanel = () => {
  if (!isMixpanelEnabled()) return;

  mixpanel.init(token!, {
    autocapture: false,
    track_pageview: false,
    persistence: 'localStorage',
    ip: false,
    debug: isDevelopment,
  });
  registerEnvironment();
  // init sends the first page view right away, before any register. Turning page views on
  // afterwards (passing `autocapture` makes set_config restart the tracking) keeps
  // `environment` on that first event.
  mixpanel.set_config({ autocapture: false, track_pageview: 'url-with-path' });
};
